"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GroupField_1 = require("./GroupField");
var configuration_1 = require("../configuration");
var GroupFieldFactory = (function () {
    function GroupFieldFactory() {
    }
    GroupFieldFactory.setAllowedGroupFields = function (input) {
        this._allowedGroupFields = input;
    };
    GroupFieldFactory.getGroupField = function (key) {
        if (!GroupFieldFactory.isKeyAllowed(key.toLowerCase())) {
            configuration_1.PlanConfiguration.logger.warn("WARNING: grouping key " + key + " is not allowed!");
            return undefined;
        }
        switch (key.toLowerCase()) {
            case "frequency":
                return new GroupField_1.GroupField({ dataField: "frequency" });
            case "marketer":
                return new GroupField_1.GroupField({ dataField: "marketerName" });
            case "adformat":
                return new GroupField_1.GroupField({
                    tableField: "conditions.online.adFormat",
                    dataField: "additionalData.specialPriceData.proprietaryName",
                    displayField: "additionalData.specialPriceData.proprietaryName",
                    notFoundText: "Unbekannte / keine Werbeform"
                });
            case "medium":
                return new GroupField_1.GroupField({ dataField: "medium.key", displayField: "medium.longTitle" });
            case "mediumtype":
                return new GroupField_1.GroupField({ dataField: "mediumType.title" });
            case "tag":
                return new GroupField_1.GroupField({ dataField: "group" });
            case "nogroup":
                return undefined;
            case "postertype":
                return new GroupField_1.GroupField({ dataField: "additionalData.posterType" });
            default:
                configuration_1.PlanConfiguration.logger.warn("WARNING: grouping key " + key + " is unknown");
                return undefined;
        }
    };
    GroupFieldFactory.isKeyAllowed = function (key) {
        if (!key) {
            return false;
        }
        return _.contains(this._allowedGroupFields, key);
    };
    GroupFieldFactory.getAllGroupFields = function () {
        var groupFields = [];
        this._allowedGroupFields.forEach(function (groupFieldString) {
            try {
                var groupField = GroupFieldFactory.getGroupField(groupFieldString);
                if (groupField) {
                    groupFields.push(groupField);
                }
            }
            catch (error) {
                console.log("groupField not found!");
                console.log(error);
            }
        });
        return groupFields;
    };
    return GroupFieldFactory;
}());
exports.GroupFieldFactory = GroupFieldFactory;
//# sourceMappingURL=GroupFieldFactory.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/GroupFieldFactory.js
// module id = 7
// module chunks = 0